/**
 * @author Owais Liaquat Ali
 * @datetime May, 29th 2023
 * @description: This class is for date time parsed.
 */
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  activityParseDate,
  convertParseDateTime,
  extractDateTimeFromDateString,
} from 'src/app/shared/utils/utility.service';
import { StateManagementService } from '../../../../shared/services/state-management.service';
import { enUS, fr } from 'date-fns/locale';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';

@Pipe({
  name: 'parsedActivityDateTime',
})
export class ParsedActivityDateTimePipe implements PipeTransform {
  constructor(private translate : TranslateService, private stateManagementService: StateManagementService){}
  transform(
    date: string,
    parseFormat: `t` | `MMM dd` | `MMM yyyy`,
    isYesterday: boolean = true
  ): any {
    if (!date) return null;
    const language = this.stateManagementService.getUserLanguage();
    const locale: Locale = language === LANG_CONST.FRENCH ? fr : enUS
    return activityParseDate(
      extractDateTimeFromDateString(String(date)),
      "yyyy-MM-dd'T'HH:mm:ss",
      parseFormat,
      isYesterday,
      this.translate,
      locale
    );
  }
}
